import { useDocumentActivities } from '../../../../api/activities/hooks';
import { ActivitiesSearchParams } from '../../../../api/activities/types/ActivityParams';
import { EMPTY_ARR } from '../../../../constants';
import { useTableParams } from '../../../../hooks';
import { DEFAULT_PAGINATION, DEFAULT_SORTING } from '../../../Table';
import { DocumentActivitiesTableProps } from '../../types/DocumentActivitiesTableProps';
import { useActivitiesTable } from '../useActivitiesTable';

export const useDocumentActivitiesTable = ({
  documentId,
  documentDefinition,
  searchParams,
  perPage = DEFAULT_PAGINATION.perPage,
}: {
  documentId: DocumentActivitiesTableProps['documentId'];
  documentDefinition: DocumentActivitiesTableProps['documentDefinition'];
  searchParams?: ActivitiesSearchParams;
  perPage?: number;
}) => {
  const { tableProps } = useTableParams(DEFAULT_SORTING, perPage);

  const { activities, meta } = useDocumentActivities(
    documentId,
    documentDefinition,
    tableProps.pagination,
    tableProps.sorting,
    searchParams,
  );

  const { columns } = useActivitiesTable();

  return {
    activities: activities ?? EMPTY_ARR,
    meta,
    columns,
    tableProps,
  };
};
